import React, { useEffect, useState } from 'react';
import {
  announcementsListRequest,
  getFeatureListRequest,
  getMyProfileRequest,
  getOrganizationFeaturesRequest,
  kudosCardsRequest,
  kudosListRequest
} from '../../../helpers/api';
import Card from '../../common/cards/Card';
import styles from './styles.module.scss';
import classNames from 'classnames';
import KudosCard from '../../common/cards/KudosCard';
import { useDispatch } from 'react-redux';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import StyledTab from '../../common/tabs/SimpleTab';
import SimpleTabs from '../../common/tabs/SimpleTabs';
import { a11yProps, checkDateToday } from '../../../helpers/utils';
import TabPanel from '../../common/tabs/SimpleTabPanel';
import Loader from '../../common/Loader';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import SwipeableViews from 'react-swipeable-views';
import Eof from '../../common/Eof';
import useDesktopDisplay from '../../../hooks/useDesktopDisplay';
import LeaderBoard from '../../common/cards/LeaderBoard';
import AddCurrentMood from '../../common/AddCurrentMood';
import mood1 from '../../../assets/icons/moodTracker/mood1.svg';
import mood2 from '../../../assets/icons/moodTracker/mood2.svg';
import mood3 from '../../../assets/icons/moodTracker/mood3.svg';
import mood4 from '../../../assets/icons/moodTracker/mood4.svg';
import mood5 from '../../../assets/icons/moodTracker/mood5.svg';
import CardSlider from '../../common/cards/CardSlider';
import { routes } from '../../../assets/routes';
import { useHistory } from 'react-router-dom';
import Logo from '../../../assets/icons/logo.png';
import { getPermissionStatus, request } from '../../../firebase';
import {
  addContentAction,
  addFabAction,
  closeSliderDialogAction,
  openSliderDialogAction
} from '../../../reactRedux/Actions/showSliderDialogAction';
import AccessNotificationDialog from '../../_dialogContent/AccessNotificationDialog';
import { modules } from '../../../helpers/modules';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { getMoodTrackerAverageRequest, sendDeviceInfoRequest } from './api';
import Button from '@mui/material/Button';
import { ChangeLog } from '../../common/changeLog';
import InfiniteScroll from 'react-infinite-scroll-component';
import BackToTopButton from '../../common/BackToTopButton';
import { setUserInfo } from '../../../reactRedux/Actions/userAction';
import { useTranslation } from '../../../i18n/LanguageProvider';

const Home = () => {
  const { t, isRtl } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useDesktopDisplay();
  const openSliderDialog = () => dispatch(openSliderDialogAction());
  const closeDialog = () => dispatch(closeSliderDialogAction());
  const setDialogContent = (content) => dispatch(addContentAction(content));
  const setDialogFab = (fab) => dispatch(addFabAction(fab));
  const history = useHistory();
  const userInfoUpdate = (data) => dispatch(setUserInfo(data));
  const [organizationName, setOrganizationName] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [organizationLogo, setOrganizationLogo] = useState(null);
  const [cardId, setCardId] = useState(null);
  const [showAnnouncement, setShowAnnouncement] = useState();
  const [isRemoveKudosActive, setIsRemoveKudosActive] = useState(false);

  const generalOrOrgValues =
    cardId === 'organization_value'
      ? true
      : cardId === 'general_value'
      ? false
      : null;
  const cardIdValue = isNaN(cardId) ? null : cardId;

  const { isLoading: organizationFeaturesIsLoading } = useQuery(
    ['organizationFeatures'],
    getOrganizationFeaturesRequest,
    {
      onSuccess(response) {
        response.data.map((feat) => {
          if (feat.feature_name === 'show_announcement_in_main_page') {
            if (feat.active) {
              setShowAnnouncement(true);
            }
          }
        });
      }
    }
  );

  const { data: valuesData } = useQuery(
    ['kudosCards', 'isValue'],
    () => kudosCardsRequest(true),
    {
      initialData: [],
      select: React.useCallback((data) => data?.data, []),
      onError(err) {
        toast.error(err.response?.data?.detail || t('common.errorFormal'));
      }
    }
  );

  const { isLoading: announcementsIsLoading, data: announcementsData } =
    useInfiniteQuery(
      ['announcementsList'],
      ({ pageParam = 1 }) => announcementsListRequest(pageParam),
      {
        select: React.useCallback(
          (data) => data?.pages.flatMap((announcement) => announcement.data),
          []
        ),
        getNextPageParam: (lastPage, allPages) => {
          const nextPage = allPages.length + 1;
          return lastPage.data.length !== 0 ? nextPage : undefined;
        },
        onError(err) {
          toast.error(err.response?.data?.detail);
        }
      }
    );

  useQuery(['myProfile'], getMyProfileRequest, {
    onSuccess(response) {
      setOrganizationName(response.organization.name);
      setOrganizationLogo(response.organization.logo?.thumbnail);
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  const { data } = useQuery(['myProfile'], getMyProfileRequest, {
    onSuccess(response) {
      userInfoUpdate({
        username: response.username,
        credit: response.credit,
        score: response.score,
        full_name: `${response.first_name} ${response.last_name}`,
        avatar: response?.avatar?.thumbnail
      });
    },
    onError(err) {
      toast.error(err.response?.data.detail);
    }
  });

  const {
    isLoading: myKudosIsLoading,
    data: myKudosData,
    hasNextPage: myKudosHasNextPage,
    fetchNextPage: myKudosFetchNextPage,
    isFetchingNextPage: myKudosIsFetchingNextPage
  } = useInfiniteQuery(
    ['kudos', 'list', 'me', cardId],
    ({ pageParam = null }) =>
      kudosListRequest({
        last_id: pageParam,
        my_department: true,
        card_id: cardIdValue,
        sum_of_values: generalOrOrgValues
      }),
    {
      getNextPageParam: (lastPage) => {
        const lastIndex = lastPage.data.length - 1;
        const lastId = lastPage.data[lastIndex]?.id;
        return lastPage.data.length !== 0 ? lastId : undefined;
      },
      select: React.useCallback(
        (data) => data?.pages.flatMap((kudos) => kudos.data),
        []
      ),
      onError(err) {
        toast.error(err.response?.data?.detail);
      },
      enabled: tabIndex === 1
    }
  );

  const {
    isLoading: allKudosIsLoading,
    data: allKudosData,
    hasNextPage: allKudosHasNextPage,
    fetchNextPage: allKudosFetchNextPage,
    isFetchingNextPage: allKudosIsFetchingNextPage,
    isFetching: allKudosIsFetching
  } = useInfiniteQuery(
    ['kudos', 'list', 'all', cardId],
    ({ pageParam = null }) =>
      kudosListRequest({
        last_id: pageParam,
        card_id: cardIdValue,
        sum_of_values: generalOrOrgValues
      }),
    {
      getNextPageParam: (lastPage) => {
        const lastIndex = lastPage.data.length - 1;
        const lastId = lastPage.data[lastIndex]?.id;
        return lastPage.data.length !== 0 ? lastId : undefined;
      },
      select: React.useCallback(
        (data) => data?.pages.flatMap((kudos) => kudos.data),
        []
      ),
      onError(err) {
        toast.error(err.response?.data?.detail);
      },
      enabled: tabIndex === 0
    }
  );

  const {
    isLoading: moodTrackerAverageIsLoading,
    data: moodTrackerAverageData,
    refetch: moodTrackerAverageRefetch
  } = useQuery(['moodTrackerAverage'], getMoodTrackerAverageRequest, {
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  const sendDeviceInfoRequestMutation = useMutation((d) => {
    sendDeviceInfoRequest(d);
  });
  const allMoods = [mood1, mood2, mood3, mood4, mood5];
  const setDialog = async () => {
    setDialogContent(<AccessNotificationDialog close={closeDialog} />);
    setDialogFab([
      {
        type: 'accept',
        title: t('home.notificationAccept'),
        onClickFn: () => {
          localStorage.setItem('acceptTime', new Date().getTime());
          closeDialog();
          request(sendDeviceInfoRequestMutation);
        }
      },
      {
        type: 'default',
        title: t('home.notificationReject'),
        onClickFn: () => {
          localStorage.setItem('rejectTime', new Date().getTime());
          closeDialog();
        }
      }
    ]);
    openSliderDialog();
  };
  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };

  const openAnnouncement = (announcement) => () => {
    history.push(`${routes.ANNOUNCEMENTS}/${announcement.id}`, {
      data: announcement
    });
  };

  const getFeatureListMutation = useMutation(getFeatureListRequest, {
    onSuccess(response) {
      console.log(response);
      let removeKudosFeature = response.data.find(
        (feature) => feature.feature_name === 'remove_kudos'
      );
      setIsRemoveKudosActive(
        removeKudosFeature ? removeKudosFeature.active : false
      );
    },
    onError(err) {
      toast.error(err.response?.data?.detail);
    }
  });

  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true;
    getFeatureListMutation.mutate();

    return () => {
      isMounted = false;
      getFeatureListMutation.reset();
    };
  }, []);
  useEffect(() => {
    setHeader('');
    setHeaderConfigs({
      credits: false,
      exit: false,
      back: false,
      logo: true,
      drawer: true,
      notification: true
    });
  }, []);

  useEffect(() => {
    const createOrUpdateFCMToken = async () => {
      const permissionStatus = await getPermissionStatus();
      if (permissionStatus === 'granted') {
        await request(sendDeviceInfoRequestMutation);
      } else if (permissionStatus === 'prompt') {
        const lastRejectTime = localStorage.getItem('rejectTime');
        const now = new Date();
        const lastRejectTimeOut = 10 * 24 * 3600 * 1000;
        const timeAccept = localStorage.getItem('acceptTime');
        const timeAcceptOut = 2 * 24 * 3600 * 1000;
        if (!!timeAccept && timeAccept > now - timeAcceptOut) {
          return;
        }
        if (!!lastRejectTime && lastRejectTime > now - lastRejectTimeOut) {
          return;
        }
        setTimeout(function () {
          setDialog();
        }, 5000);
      }
    };
    createOrUpdateFCMToken();
  }, []);

  useEffect(() => {
    if (!modules.greeting_mood_tracker) return;
    const localStorageId = 'lastGreetingMoodTime';
    const localStorageItem = localStorage.getItem(localStorageId);
    if (localStorageItem && checkDateToday(new Date(localStorageItem))) return;
    const now = new Date();
    localStorage.setItem('lastGreetingMoodTime', now.toISOString());
    history.push(routes.GREETING_MOOD_TRACKER);
  }, []);

  const inifinteScrollStyle = {
    width: '100% !important'
  };

  return (
    <div className={styles.page}>
      <BackToTopButton />
      <Helmet>
        <title>{t('home.title')}</title>
      </Helmet>
      {isDesktop && (
        <div className={styles.pageHeader}>
          <div>{organizationName}</div>
          {organizationLogo && (
            <a target="_blank" rel="noreferrer" href="http://o2reco.ir/">
              <img src={Logo} alt="logo" className={styles.logo} />
            </a>
          )}
        </div>
      )}
      <div className={styles.section}>
        <div className={styles.sectionTop}>
          {moodTrackerAverageIsLoading && organizationFeaturesIsLoading ? (
            <Loader size={40} />
          ) : isDesktop ? (
            <>
              <Card
                scrollable
                noPointer
                extraClass={styles.announcementDesktop}
              >
                <div
                  className={classNames(styles.sectionBody, styles.noMargin)}
                >
                  <div className={styles.question}>{t('home.news')}</div>
                  <CardSlider
                    more={announcementsData?.length > 0}
                    handleClick={() => history.push(routes.ANNOUNCEMENTS)}
                  >
                    {announcementsIsLoading ? (
                      <Loader size={40} />
                    ) : announcementsData?.length ? (
                      announcementsData?.map((announcement, i) => (
                        <Card
                          key={i}
                          extraClass={styles.announcementCard}
                          onClick={openAnnouncement(announcement)}
                          image={announcement.cover?.absolute_url}
                        >
                          {announcement.title}
                        </Card>
                      ))
                    ) : (
                      <div className={styles.emptyCard}>
                        {t('home.noAnnouncements')}
                      </div>
                    )}
                  </CardSlider>
                </div>
              </Card>
              <Card noPointer extraClass={styles.moodTrackerDesktop}>
                <AddCurrentMood
                  homePage={true}
                  reloadAvgMoodTracker={() => moodTrackerAverageRefetch()}
                />
              </Card>
            </>
          ) : showAnnouncement ? (
            <Card scrollable noPointer extraClass={styles.announcementMobile}>
              <div className={classNames(styles.sectionBody, styles.noMargin)}>
                <div className={styles.question}>{t('home.news')}</div>
                <CardSlider
                  more={announcementsData?.length > 0}
                  handleClick={() => history.push(routes.ANNOUNCEMENTS)}
                >
                  {announcementsIsLoading ? (
                    <Loader size={40} />
                  ) : announcementsData?.length ? (
                    announcementsData?.map((announcement, i) => (
                      <Card
                        key={i}
                        extraClass={styles.announcementCard}
                        onClick={openAnnouncement(announcement)}
                        image={announcement.cover?.absolute_url}
                      >
                        {announcement.title}
                      </Card>
                    ))
                  ) : (
                    <div className={styles.emptyCard}>
                      {t('home.noAnnouncements')}
                    </div>
                  )}
                </CardSlider>
              </div>
            </Card>
          ) : (
            <Card noPointer extraClass={styles.moodTracker}>
              <div className={styles.avgMood}>
                {moodTrackerAverageData !== null ? (
                  <>
                    <div className={styles.text}>
                      <div>{t('home.orgMoodAverage')}</div>
                      <p>
                        {t('home.outOfFive', { value: moodTrackerAverageData })}
                      </p>
                    </div>
                    <img
                      src={allMoods[Math.round(moodTrackerAverageData) - 1]}
                      alt={allMoods[moodTrackerAverageData]}
                      className={styles.avgIcon}
                    />
                  </>
                ) : (
                  <div className={styles.nullAvg}>{t('home.firstMood')}</div>
                )}
              </div>

              <div className={styles.hr}></div>
              <AddCurrentMood
                homePage={true}
                reloadAvgMoodTracker={() => moodTrackerAverageRefetch()}
              />
            </Card>
          )}
        </div>
      </div>

      <div className={styles.section}>
        <div className={classNames(styles.sectionTop, styles.tabsSection)}>
          <SimpleTabs value={tabIndex} handleChange={handleChange}>
            <StyledTab label={t('home.allKudos')} {...a11yProps(0)} />
            <StyledTab label={t('common.myDepartment')} {...a11yProps(1)} />
            <StyledTab label={t('home.leaderboard')} {...a11yProps(2)} />
          </SimpleTabs>
          {modules.filterByRecart && !!valuesData?.length && (
            <div className={styles.selectButton}>
              <Button variant="outlined" size="small">
                <select
                  value={cardId}
                  onChange={(e) => setCardId(e.target.value)}
                >
                  <option>{t('home.allCards')}</option>
                  {valuesData.map((value) => (
                    <option key={value.id} value={value.id}>
                      {value.title}
                    </option>
                  ))}
                  <option value={'general_value'}>
                    {t('home.generalValues')}
                  </option>
                  <option value={'organization_value'}>
                    {t('home.organizationValues')}
                  </option>
                </select>
              </Button>
            </div>
          )}
        </div>
        <div className={classNames(styles.sectionBody, styles.noMargin)}>
          <SwipeableViews
            axis={isRtl ? 'x-reverse' : 'x'}
            index={tabIndex}
            onChangeIndex={handleChangeIndex}
            className={styles.swipeArea}
          >
            {tabIndex === 0 && (
              <InfiniteScroll
                next={allKudosFetchNextPage}
                dataLength={allKudosData ? allKudosData.length : 10}
                hasMore={allKudosHasNextPage}
                scrollThreshold={0.9}
                style={inifinteScrollStyle}
                loader={
                  !allKudosIsLoading &&
                  (allKudosIsFetchingNextPage ? (
                    <Loader size={40} />
                  ) : allKudosHasNextPage ? (
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={allKudosFetchNextPage}
                    >
                      {t('common.more')}
                    </Button>
                  ) : (
                    <Eof />
                  ))
                }
              >
                <TabPanel index={0} value={tabIndex}>
                  {allKudosIsLoading ? (
                    <Loader size={40} />
                  ) : allKudosData?.length ? (
                    allKudosData?.map((kudos) => (
                      <KudosCard
                        key={kudos.id}
                        extraClass={styles.kudosCard}
                        data={kudos}
                        isOrgAdmin={data.is_org_admin}
                        isSysAdmin={data.is_sys_admin}
                        isFetching={allKudosIsFetching}
                        isRemoveKudosActive={isRemoveKudosActive}
                      />
                    ))
                  ) : (
                    <div className={classNames(styles.emptyCard, styles.kudos)}>
                      {t('home.noKudos')}
                    </div>
                  )}
                </TabPanel>
              </InfiniteScroll>
            )}
            {tabIndex === 1 && (
              <InfiniteScroll
                next={myKudosFetchNextPage}
                dataLength={myKudosData ? myKudosData.length : 10}
                hasMore={myKudosHasNextPage}
                scrollThreshold={0.8}
                style={inifinteScrollStyle}
                endMessage={<Eof />}
                loader={
                  !myKudosIsLoading && myKudosIsFetchingNextPage ? (
                    <Loader size={40} />
                  ) : (
                    <>
                      {myKudosHasNextPage && myKudosData.length >= 10 && (
                        <Button
                          fullWidth
                          variant="outlined"
                          onClick={myKudosFetchNextPage}
                        >
                          {t('common.more')}
                        </Button>
                      )}
                    </>
                  )
                }
              >
                <TabPanel index={1} value={tabIndex}>
                  {myKudosIsLoading ? (
                    <Loader size={40} />
                  ) : myKudosData.length ? (
                    myKudosData?.map((kudos, i) => (
                      <KudosCard
                        key={i}
                        extraClass={styles.kudosCard}
                        data={kudos}
                        isRemoveKudosActive={isRemoveKudosActive}
                      />
                    ))
                  ) : (
                    <div className={classNames(styles.emptyCard, styles.kudos)}>
                      {t('profile.noReceivedMine')}
                    </div>
                  )}
                </TabPanel>
              </InfiniteScroll>
            )}
            <TabPanel index={2} value={tabIndex}>
              <LeaderBoard
                isDesktop={isDesktop}
                cardId={cardIdValue}
                generalOrOrgValues={generalOrOrgValues}
              />
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
      <ChangeLog />
    </div>
  );
};

export default Home;
